// extracted by mini-css-extract-plugin
module.exports = {"chartContent":"PieCard_chartContent__2tzGP"};